import { AudioService } from './AudioService'
import { Capacitor } from '@capacitor/core'
import { NativeDriver } from './NativeAudioDriver'
import { WebDriver } from './WebAudioDriver'

const audioDriver = Capacitor.isNativePlatform()
    ? new NativeDriver()
    : new WebDriver()

const audioService = new AudioService(audioDriver)

// export enum AudioFiles {
//   NOTIFY_SOUND = 'audio/mixkit-clear-announce-tones-2861.wav',
//   REMINDER_SOUND = 'audio/mixkit-software-interface-start-2574.wav',
//   ALERT_SOUND = 'audio/mixkit-urgent-simple-tone-loop-2976.wav',
// }

export enum AudioFiles {
    // NOTIFY_SOUND = 'audio/mixkit-urgent-simple-tone-loop-2976.wav',
    // REMINDER_SOUND = 'audio/mixkit-software-interface-start-2574.wav',
    // ALERT_SOUND = 'audio/mixkit-clear-announce-tones-2861.wav',
    NOTIFY_SOUND = 'audio/mixkit-software-interface-start-2574.wav',
    REMINDER_SOUND = 'audio/mixkit-clear-announce-tones-2861.wav',
    ALERT_SOUND = 'audio/mixkit-urgent-simple-tone-loop-2976.wav',
}

audioService.load(AudioFiles.NOTIFY_SOUND)
audioService.load(AudioFiles.REMINDER_SOUND)
audioService.load(AudioFiles.ALERT_SOUND)

export { audioService }
